module.exports = __webpack_public_path__ + "assets/img/brown.d9570cd6.png";